// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"504":"86c8bbe3","1210":"cc78fc68","5473":"2586ea95","8852":"2586ea95"}[chunkId] + ".chunk.css";
};